import React from 'react';

const ShiftContext = React.createContext({
    refreshShifts: () => {}
});

export default ShiftContext;
